import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Box, Label, Popper, Button, Popover, Heading, Paragraph, Anchor } from '@zillow/constellation';
import React, { useState, useEffect, useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { commaSeparateNumber } from '../../utils/zhl-calculator.js';
import TextField from '../Fields/TextField.js';
import { useLastValidDownPaymentValues, FieldConfig } from './DownPaymentCalculator.utils.js';

var popover = /*#__PURE__*/React.createElement(Popover, {
  header: /*#__PURE__*/React.createElement(Heading, {
    level: "6"
  }, "Down payment"),
  body: /*#__PURE__*/React.createElement(Paragraph, null, "A", ' ', /*#__PURE__*/React.createElement(Anchor, {
    href: "https://www.zillow.com/learn/down-payment-on-a-house/"
  }, "down payment"), ' ', "is the cash payment you make at closing toward the purchase of a home. Most loans require a down payment of at least 3% of the home purchase price. While not required, putting 20% down may help you avoid private mortgage insurance (PMI).", ' ', /*#__PURE__*/React.createElement(Anchor, {
    href: "https://www.zillow.com/learn/private-mortgage-insurance/"
  }, "Learn more."))
});
var DownPaymentFields = function DownPaymentFields() {
  var form = useFormContext();
  var setValue = form.setValue,
    getValues = form.getValues;
  var lastValidValues = useLastValidDownPaymentValues(form);
  var lastValidPercentageValue = lastValidValues.fields.percentage;
  var percentageHints = [3, 3.5, 5, 10, 20, 'Other'];
  var _useState = useState(function getDefaultOtherSelection() {
      return !percentageHints.includes(Number(lastValidPercentageValue));
    }),
    _useState2 = _slicedToArray(_useState, 2),
    isOtherSelected = _useState2[0],
    setIsOtherSelected = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    forceRender = _useState4[1];
  useEffect(function () {
    setTimeout(function () {
      return forceRender({});
    }, 100);
  }, []);
  var otherInputRef = useRef(null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
    label: "Home price",
    leftAdornment: "$",
    name: FieldConfig.homePrice.name,
    config: FieldConfig.homePrice.config,
    autoComplete: "off",
    format: commaSeparateNumber,
    required: true
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: '$spacing.xxs'
    }
  }, /*#__PURE__*/React.createElement(Label, null, "Down payment %\xA0"), /*#__PURE__*/React.createElement(Popper, {
    style: {
      alignSelf: 'center'
    },
    triggered: popover
  })), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'start',
      gap: '$spacing.xs',
      marginBottom: '$spacing.sm'
    }
  }, percentageHints.map(function (hint) {
    var selected = !isOtherSelected && Number(lastValidPercentageValue) === hint || hint === 'Other' && isOtherSelected;
    return /*#__PURE__*/React.createElement(Box, {
      as: Button,
      "aria-selected": selected,
      key: hint,
      size: "sm",
      type: "button",
      onClick: function setPercentageFieldValue() {
        if (hint === 'Other') {
          setValue('percentage', getValues(FieldConfig.other.name));
          setIsOtherSelected(true);
          setTimeout(function () {
            var _otherInputRef$curren;
            (_otherInputRef$curren = otherInputRef.current) === null || _otherInputRef$curren === void 0 || _otherInputRef$curren.focus();
          }, 50);
        } else {
          setIsOtherSelected(false);
          setValue('percentage', hint);
        }
      },
      sx: {
        '&&&&': {
          backgroundColor: "" + (selected ? '$colors.coolGray300' : '$colors.textWhite'),
          borderColor: "" + (selected ? '$colors.black' : '$colors.gray300'),
          color: '$colors.backgroundDark',
          borderRadius: '$radii.pill',
          padding: '$spacing.xxs',
          width: '90px'
        }
      }
    }, hint === 'Other' ? 'Other' : hint + '%');
  }))), /*#__PURE__*/React.createElement(Box, null, isOtherSelected && /*#__PURE__*/React.createElement(TextField, {
    textInputRef: otherInputRef,
    label: "Other",
    rightAdornment: "%",
    name: FieldConfig.other.name,
    config: FieldConfig.other.config,
    autoComplete: "off",
    onChange: function onChange() {
      setValue('percentage', getValues(FieldConfig.other.name));
    }
  })));
};
var DownPaymentFields$1 = DownPaymentFields;

export { DownPaymentFields$1 as default };
